module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-bg-monitor-2c2829c72083eed280e77e7eca6560e7.png";